import RatgeberTemplate from "@/components/RatgeberTemplate";
import { getRatgeberBySlug } from "@/data/ratgeberData";
import Footer from "@/components/Footer";

const RatgeberMuedigkeit = () => {
  const content = getRatgeberBySlug("muedigkeit");
  if (!content) return null;

  return (
    <>
      <RatgeberTemplate content={content} />
      <Footer />
    </>
  );
};

export default RatgeberMuedigkeit;
